const STATE_COMPLIANCE_DEADLINE_TASK_TITLE_PREFIXES = [
  "State Annual Report",
  "State Franchise Tax",
  "California Statement of Information",
];

export const isStateComplianceDeadlineTask = (
  task: { base_task_template: { uuid: string }; task_title?: string | null },
  relevantBaseTaskTemplateIds: string[]
): boolean => {
  if (relevantBaseTaskTemplateIds.includes(task.base_task_template.uuid)) {
    return true;
  }
  return STATE_COMPLIANCE_DEADLINE_TASK_TITLE_PREFIXES.some((prefix) =>
    task.task_title?.startsWith(prefix)
  );
};
